import theme from '@styles/theme';
export default {
  containerMobile: (closed: boolean, background?: string, color?: string) => ({
    position: 'fixed',
    width: 'calc(100% - 28px)',
    left: 16,
    top: 12,
    height: closed ? '0' : 'auto',
    opacity: closed ? '0' : '1',
    padding: closed ? '0' : '16px',
    backgroundColor: background || theme.rawColors.dirtyPink200,
    color: color || theme.rawColors.darkGrey700,
    display: 'flex',
    alignItems: 'flex-start',
    boxShadow: `0 2px 8px ${theme.rawColors.lightGrey500}`,
    transition: 'all .3s linear',
    marginTop: '24px',
    '&:first-of-type': {
      marginTop: '0'
    }
  }),
  message: (closed?: boolean) => ({
    padding: closed ? '0' : '0 18px',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.smallText,
    lineHeight: '140%',
    opacity: closed ? '0' : '1'
  }),
  buttonStyles: (closed: boolean) => ({
    button: {
      height: closed ? '0' : '100%',
      opacity: closed ? '0' : '1'
    }
  }),
  closeButtonStyles: (closed: boolean) => ({
    marginLeft: 'auto',
    lineHeight: closed ? '0' : 'initial',
    height: closed && '0'
  }),
  infoIconStyles: (closed: boolean) => ({
    width: closed ? '0' : '20px',
    height: closed ? '0' : '20px',
    opacity: closed ? '0' : '1'
  }),
  refresh: {
    textDecoration: 'underline',
    cursor: 'pointer'
  }
};